import axios from 'axios';
import { setupAxios } from '../../auth';
import type { InvoiceJourneyData, VesselInvoiceApi } from '../types/invoice';

const api = axios.create({ baseURL: process.env.REACT_APP_ACCOUNTS_API_URL || '' });
setupAxios(api);

type ApiEnvelope<T> = { success?: boolean; data?: T }

function unwrapData<T>(raw: unknown): T | null {
  if (raw && typeof raw === 'object' && 'data' in raw) {
    return (raw as ApiEnvelope<T>).data ?? null;
  }
  return (raw as T) ?? null;
}

export const getVesselInvoices = async (filters?: any): Promise<VesselInvoiceApi[]> => {
  const { data } = await api.get('/vessel-invoices', { params: filters });
  return Array.isArray(data) ? (data as VesselInvoiceApi[]) : (data?.data || []);
};

export const getVesselInvoiceById = async (id: number | string): Promise<VesselInvoiceApi | null> => {
  const { data } = await api.get(`/vessel-invoices/${id}`);
  return unwrapData<VesselInvoiceApi>(data);
};

export const getVesselInvoiceJourney = async (id: number | string): Promise<InvoiceJourneyData | null> => {
  const { data } = await api.get(`/vessel-invoices/${id}/journey`);
  return unwrapData<InvoiceJourneyData>(data);
};

export const updateVesselInvoiceStatus = async (
  id: number | string,
  payload: {
    status: 'APPROVED' | 'REJECTED';
    transactionId?: string;
    remarks?: string;
    attachment?: File | null;
  },
): Promise<VesselInvoiceApi | null> => {
  const body = new FormData();
  body.append('status', payload.status);
  if (payload.transactionId) {
    body.append('transaction_id', payload.transactionId);
  }
  if (payload.remarks) {
    body.append('remarks', payload.remarks);
  }
  if (payload.attachment) {
    body.append('attachment', payload.attachment);
  }
  const { data } = await api.patch(`/vessel-invoices/${id}/status`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return unwrapData<VesselInvoiceApi>(data);
};

export const getGoodsReceiptById = async (id: number | string): Promise<any> => {
  const { data } = await api.get(`/vessel-invoices/goods-receipt/${id}`);
  return unwrapData<any>(data);
};

export const getPurchaseOrderById = async (id: number | string): Promise<any> => {
  const { data } = await api.get(`/vessel-invoices/purchase-order/${id}`);
  return unwrapData<any>(data);
};

export const getQuotationById = async (id: number | string): Promise<any> => {
  const { data } = await api.get(`/vessel-invoices/quotation/${id}`);
  return unwrapData<any>(data);
};

export const getRfqById = async (id: number | string): Promise<any> => {
  const { data } = await api.get(`/vessel-invoices/rfq/${id}`);
  return unwrapData<any>(data);
};

export const getRequisitionById = async (id: number | string): Promise<any> => {
  const { data } = await api.get(`/vessel-invoices/requisition/${id}`);
  return unwrapData<any>(data);
};
